import colors from '@sportninja/common/constants/appColors'

/**
 * Design tokens for modal components
 * Extracted from common patterns across all modal implementations
 */
export const MODAL_TOKENS = {
  // Dimensions
  WIDTH_DESKTOP: '40vw',
  WIDTH_MOBILE: '100%',
  HEIGHT_MOBILE: '100vh',
  HEIGHT_DESKTOP: 'auto',

  // Colors
  BG_SECONDARY_300: colors.SECONDARY_300,
  BG_SECONDARY_400: colors.SECONDARY_400,
  MASK_COLOR: 'rgba(6, 10, 16, 0.8)',
  BORDER_COLOR: colors.SOFT_STEEL,

  // Effects
  MASK_BLUR: '2px',
  BORDER_RADIUS: 8,
  BORDER_RADIUS_MOBILE: 0,

  // Spacing
  PADDING_HEADER: '16px',
  PADDING_BODY: '16px',
  PADDING_FOOTER: '16px',
  MARGIN_DESKTOP: '24px',
  MARGIN_MOBILE: '0',

  // Z-index
  Z_INDEX_WRAPPER: 10002,
  Z_INDEX_MASK: 10001,
  // Added once per `elevated` level so each nesting depth gets its own layer.
  // Must stay > 1 so an elevated modal's mask clears the wrapper below it.
  Z_INDEX_ELEVATION_STEP: 20,
  // Tooltips/popovers rendered from inside a modal. antd's default (1070) sits
  // far below the modal wrapper, so they'd render underneath it. Kept well
  // above the deepest elevation level.
  Z_INDEX_TOOLTIP: 10500,

  // Breakpoints
  MOBILE_BREAKPOINT: 768,
} as const
